module.exports = __webpack_public_path__ + "static/media/partner-logo9.291559d7.png";